module.exports = __webpack_public_path__ + "img/logo_tele.27bdf3ea.svg";